export const EFFECTS_ON_ROADWAY = ['noRoadHit', 'whiteLine', 'centerLine', 'outsideLane', 'allLanes']
